import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

// Tip entry (added to the card amount). value is a string in CHF.
export const TipInput = ({ value, onChange, base }) => {
  const roundUp = Math.ceil(Number(base || 0) / 5) * 5 - Number(base || 0);
  const quick = [2, 5, 10];
  return (
    <div className="space-y-1.5" data-testid="tip-input-block">
      <Label className="text-xs text-slate-500 uppercase font-semibold">Trinkgeld (CHF, auf Karte)</Label>
      <div className="flex gap-2">
        <Input type="number" step="0.50" min="0" value={value} onChange={(e) => onChange(e.target.value)} placeholder="0.00"
          className="bg-slate-50 border-slate-200 text-slate-900 rounded-lg text-lg font-bold" data-testid="tip-input" />
        {Number(value) > 0 && (
          <button type="button" onClick={() => onChange('')} className="px-3 text-xs font-semibold text-slate-500 hover:text-red-600" data-testid="tip-clear">×</button>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {quick.map((q) => (
          <button key={q} type="button" onClick={() => onChange(String(q))} data-testid={`tip-quick-${q}`}
            className="px-2.5 py-1 rounded-lg border border-slate-200 text-xs font-semibold text-slate-600 hover:border-emerald-400 hover:bg-emerald-50 transition-colors">
            +{q}.–
          </button>
        ))}
        {roundUp > 0.004 && (
          <button type="button" onClick={() => onChange(roundUp.toFixed(2))} data-testid="tip-round-up"
            className="px-2.5 py-1 rounded-lg border border-slate-200 text-xs font-semibold text-slate-600 hover:border-emerald-400 hover:bg-emerald-50 transition-colors">
            Aufrunden auf {(Number(base) + roundUp).toFixed(2)}
          </button>
        )}
      </div>
    </div>
  );
};

// Books the tip as its own "Trinkgeld" line (counts as revenue, category Trinkgeld).
export const bookTip = async (API, amount, note) => {
  if (!(Number(amount) > 0)) return;
  const { data } = await API.post('/cash-register/tip-item');
  await API.post('/cash-register/entries', {
    item_id: data.id, quantity: 1, custom_price: Number(Number(amount).toFixed(2)),
    payment_method: 'card', cash_amount: 0, card_amount: Number(Number(amount).toFixed(2)),
    notes: note || undefined,
  });
};
